/**
 * Handle hero carousel/slider
 */
function setUpHeroCarousel() {
  const splideElement = document.querySelector('.splide');

  if (Splide) {
    const slide = new Splide(splideElement, {
      type: 'loop',
      arrows: false,
      autoplay: true,
      classes: {
        pagination: 'splide__pagination b-slider-indicator',
        page: 'splide__pagination__page b-slider-indicator__button',
      },
    });
    slide.mount();
  }
}

/**
 * Handle mobile nav menu
 */
function setUpMobileNavMenu() {
  const navToggler = document.querySelector('nav button.primary-nav__toggle-btn');
  const navOverlay = document.querySelector('nav div.primary-nav__overlay');

  if (!navToggler || !navOverlay) return;
  registerEventMobileNavMenu(navToggler, navOverlay);
}

/**
 * Register nav menu mobile's button event listener
 */
function registerEventMobileNavMenu(toggler: Element, overlay: Element) {
  const navMenu = document.querySelector('nav div.primary-nav__content');
  const body = document.querySelector('body');
  const activeClass = 'is-active';

  if (!navMenu || !body) return;

  toggler.addEventListener('click', (event) => {
    event.stopPropagation();
    toggler.classList.toggle(activeClass);
    navMenu.classList.toggle(activeClass);

    if (navMenu.classList.contains(activeClass)) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'unset';
    }
  });

  overlay.addEventListener('click', (event) => {
    event.stopPropagation();
    toggler.classList.remove(activeClass);
    navMenu.classList.remove(activeClass);
    body.style.overflow = 'unset';
  });
}

/**
 * Handle tabbed content
 * component is available in page about and tos
 */
function setUpTabbedContent() {
  const wrapper = document.querySelector('.b-menu');
  
  if (!wrapper) return;
  registerEventTabbedContent(wrapper);
}

/**
 * Register tabbed content's buttons event listener
 */
function registerEventTabbedContent(wrapper: Element) {
  const buttons = wrapper.querySelectorAll('button.b-menu-label__button');
  const scrollToTop = wrapper.getAttribute('data-scroll-top');
  const contentWrapper = wrapper.querySelector('.b-menu-detail');
  
  if (!contentWrapper) return;
  
  const contents = Array.from(contentWrapper.children);
  const activeClass = 'is-active';

  const onClickTab = (event: Event) => {
    const target = event.target as Element;
    if (!target) return;
    
    removeActiveTab();
    target.classList.add(activeClass);
    
    const targetContent = wrapper.querySelector(`[data-id="${target.id}"]`);
    if (!targetContent) return;

    targetContent.classList.add(activeClass);

    if (scrollToTop) {
      const scrollTargetEl = document.querySelector(scrollToTop);
      if (scrollTargetEl) {
        scrollTargetEl.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  const removeActiveTab = () => {
    buttons.forEach((button) => {
      button.classList.remove(activeClass);
    });
    contents.forEach((content) => {
      content.classList.remove(activeClass);
    });
  }

  buttons.forEach((button) => {
    button.removeEventListener('click', onClickTab);
    button.addEventListener('click', onClickTab);
  });

  removeActiveTab();
  buttons[0].classList.add(activeClass);
  contents[0].classList.add(activeClass);
}

/**
 * Handle footer links accordion on mobile view
 */
function setUpFooterLinksAccordion() {
  const buttons = document.querySelectorAll('.b-footer button.footer-menu__title-btn');
  const activeClass = 'is-active';

  buttons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      btn.classList.toggle(activeClass);
      toggleMenu(btn.id);
    });
  });

  const toggleMenu = (menuId: string) => {
    const menu = document.querySelector(`ul[data-section="${menuId}"]`);

    if (!menu) return;
    menu.classList.toggle(activeClass);
  };
}

/**
 * Handle accordion in domain pricing section
 */
function setUpDomainPricingAccordion() {
  const pricingSection = document.querySelector('.lisensi-domain__tlds') as HTMLElement;
  const toggleBtns = document.querySelectorAll('button[data-toggle="domainPricing"]');
  const activeClass = 'is-active';
  
  if (!pricingSection) return;
    
  const showPricingSection = () => {
    if (pricingSection.classList.contains(activeClass)) {
      pricingSection.style.maxHeight = pricingSection.scrollHeight + 'px';

      requestAnimationFrame(() => {
        pricingSection.style.maxHeight = '0';
      });
  
      toggleButtonClass('remove');
      pricingSection.classList.remove(activeClass);
    } else {
      toggleButtonClass('add');
      pricingSection.classList.add(activeClass);
      pricingSection.style.maxHeight = pricingSection.scrollHeight + 'px';
    }
  }

  const toggleButtonClass = (method: 'add' | 'remove') => {
    toggleBtns.forEach((btn) => btn.classList[method](activeClass));
  }

  toggleBtns.forEach((btn) => btn.addEventListener('click', showPricingSection));
}

/**
 * Handle button dropdown
 */
function setUpButtonDropdown() {
  const buttons = document.querySelectorAll('.b-button-popup');
  registerEventButtonDropdown(buttons);
}

/**
 * Handle custom select input component
 */
function setUpSelectInput() {
  const selects = document.querySelectorAll('.b-select');

  selects.forEach((select) => {
    const input = select.querySelector('input.b-select__input') as HTMLInputElement;
    const inputHidden = select.querySelector('input.b-select__input-hidden') as HTMLInputElement;
    const optionsWrapper = select.querySelector('.b-select__options');
    const activeClass = 'is-active';

    console.log(input, inputHidden, optionsWrapper);
    if (!input || !optionsWrapper) return;

    const isInputKeydownDisable = input.getAttribute('data-keydown-disable') !== null;

    input.addEventListener('click', (event) => {
      event.stopPropagation();
      select.classList.toggle(activeClass);
    });
    
    // toggle show/hide select options
    const toggleSelect = (isOpen = true) => {
      setTimeout(() => {
        if (isOpen) {
          select.classList.add(activeClass);
        } else {
          select.classList.remove(activeClass);
        }
        optionsWrapper.setAttribute('aria-hidden', `${!isOpen}`);
      }, 250);
    }

    // open select options on focus
    input.addEventListener('focus', () => toggleSelect());

    // close select options on blur
    input.addEventListener('blur', () => {
      toggleSelect(false);
    });

    let selectedOption = '';

    // map ArrowUp, ArrowDown, and Enter to navigate between options
    input.addEventListener('keydown', (e) => {
      e.preventDefault();
      if (isInputKeydownDisable) return;

      const event = e as KeyboardEvent;

      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        const optionsLength = optionsWrapper.children.length;
        const currentIndex = Array.from(optionsWrapper.children)
          .findIndex((b) => {
            return b.textContent === selectedOption;
          });
        let nextIndex = 0;

        if (event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + optionsLength) % optionsLength
        } else {
          nextIndex = (currentIndex + 1) % optionsLength
        }

        selectedOption = optionsWrapper.children[nextIndex].textContent || '';

        Array.from(optionsWrapper.children).forEach((b) => {
          b.classList.remove(activeClass);
          if (b.textContent === selectedOption) {
            b.classList.add(activeClass);
          }
        });
      }

      if (event.key === 'Enter') {
        if (selectedOption) {
          input.value = selectedOption;

          if (inputHidden) {
            inputHidden.value = selectedOption;
          }

          selectedOption = '';
          toggleSelect(false);
          input.blur();
        }
      }
    });

    // assign selected option value to select's inputs
    optionsWrapper.addEventListener('click', (event) => {
      event.stopPropagation();
      const optionTarget = event.target as Element;

      if (optionTarget.classList.contains('b-select__button')) {
        input.value = optionTarget.textContent || '';

        if (inputHidden) {
          inputHidden.value = optionTarget.getAttribute('data-value') || '';
        }
      }
    });
  });
}

/**
 * Register button dropdown event listener
 */
function registerEventButtonDropdown(buttons: NodeListOf<Element>) {
  buttons.forEach((btn) => {
    const toggler = btn.querySelector('button.b-button-popup__button');
    const menu = btn.querySelector('.b-button-popup__menu');
    const activeClass = 'is-active';

    if (!toggler || !menu) return;

    const togglePopup = (isOpen = true) => {
      setTimeout(() => {
        if (isOpen) {
          menu.classList.add(activeClass);
        } else {
          menu.classList.remove(activeClass);
        }
      }, 150);
    }

    toggler.addEventListener('click', (event) => {
      event.stopPropagation();
      menu.classList.toggle(activeClass);
    });

    toggler.addEventListener('focus', () => {
      togglePopup(true);
    });

    toggler.addEventListener('blur', () => {
      togglePopup(false);
    });
  });
}

/**
 * Render whatsapp chat widget
 */
function setUpChatWidget() {
  const wrapper = document.createElement('div');
  wrapper.className = 'fixed-button';
  wrapper.innerHTML = `
  <style>
  div.fixed-button {
    position: fixed;
    z-index: 5;
    bottom: 20px;
    right: 20px;
  }
  a.fixed-button__round {
    height: 50px;
    width: 50px;
    border: none;
    border-radius: 50%;
    box-shadow: 2px 3px 3px rgba(0,0,0,0.07);

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #59b771;
    transition: none !important;
  }
  a.fixed-button__round:hover, a.fixed-button__round:active {
    background-color: #228b9f;
  }
  a.fixed-button__round svg {
    width: auto;
    height: 27px;
  }
  </style>
  <a href="https://wa.me/62811127610" target="_blank" class="fixed-button__round">
    <svg
      width="29.999977"
      height="30"
      viewBox="0 0 29.999977 30"
      version="1.1"
      id="svg33"
      sodipodi:docname="wa-icon.svg"
      inkscape:version="1.1 (c68e22c387, 2021-05-23)"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:dc="http://purl.org/dc/elements/1.1/">
      <defs
        id="defs37" />
      <sodipodi:namedview
        id="namedview35"
        pagecolor="#ffffff"
        bordercolor="#999999"
        borderopacity="1"
        inkscape:pageshadow="0"
        inkscape:pageopacity="0"
        inkscape:pagecheckerboard="0"
        showgrid="false"
        inkscape:zoom="11.266667"
        inkscape:cx="-10.961538"
        inkscape:cy="15.488165"
        inkscape:window-width="1366"
        inkscape:window-height="715"
        inkscape:window-x="-8"
        inkscape:window-y="22"
        inkscape:window-maximized="1"
        inkscape:current-layer="Solutions"
        fit-margin-top="0"
        fit-margin-left="0"
        fit-margin-right="0"
        fit-margin-bottom="0" />
      <title
        id="title24">05DBCE71-FBD0-41A1-B0A6-3D805B1EAF45</title>
      <g
        id="Solutions"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        transform="translate(-8.0000199,-7)">
        <path
          d="M 23.266296,7 C 15.141361,7 8.5312312,13.560455 8.5312312,21.624318 c 0,2.608149 0.697987,5.161169 2.0202268,7.395585 l -2.5308113,7.465422 c -0.047143,0.139188 -0.012078,0.293084 0.090877,0.397889 C 8.1858415,36.959091 8.2866532,37 8.3896078,37 c 0.039448,0 0.079188,-0.0059 0.1179545,-0.01831 l 7.7844157,-2.473636 c 2.130195,1.138149 4.537792,1.738928 6.974415,1.738928 8.124156,9.8e-5 14.733604,-6.559675 14.733604,-14.622662 C 37.999997,13.560455 31.390549,7 23.266296,7 Z m 0,26.200714 c -2.29276,0 -4.513442,-0.662045 -6.422338,-1.914643 -0.06419,-0.04218 -0.138701,-0.0638 -0.213701,-0.0638 -0.03964,0 -0.07938,0.006 -0.118052,0.01831 l -3.899513,1.239546 1.258831,-3.713864 c 0.04071,-0.120195 0.02036,-0.25276 -0.05464,-0.355227 -1.453637,-1.986234 -2.222046,-4.332955 -2.222046,-6.786721 0,-6.384058 5.235779,-11.577954 11.671364,-11.577954 6.434805,0 11.67,5.193896 11.67,11.577954 0,6.383279 -5.235,11.576396 -11.669903,11.576396 z"
          id="XMLID_470_"
          fill="#ffffff"
          fill-rule="nonzero" />
        <path
          d="m 30.198439,24.238409 c -0.05844,-0.02805 -2.24552,-1.105032 -2.634156,-1.244903 -0.158669,-0.05698 -0.328636,-0.112597 -0.509416,-0.112597 -0.295324,0 -0.543409,0.147175 -0.736655,0.436266 -0.218474,0.324741 -0.879838,1.097825 -1.084189,1.328767 -0.02669,0.03049 -0.06312,0.06691 -0.08494,0.06691 -0.01958,0 -0.358052,-0.139383 -0.460519,-0.183896 -2.346137,-1.019123 -4.126948,-3.46987 -4.371137,-3.883149 -0.03487,-0.05942 -0.03633,-0.0864 -0.03662,-0.0864 0.0086,-0.03146 0.08747,-0.110552 0.128182,-0.151364 0.119123,-0.117857 0.248182,-0.273214 0.373052,-0.423507 0.05912,-0.0712 0.118344,-0.1425 0.176493,-0.209707 0.181169,-0.21078 0.261818,-0.374416 0.355325,-0.563961 l 0.04899,-0.09847 c 0.228311,-0.453604 0.03331,-0.836397 -0.02971,-0.96 -0.05172,-0.103442 -0.975195,-2.332208 -1.073377,-2.566364 -0.236104,-0.565032 -0.548084,-0.828117 -0.981623,-0.828117 -0.04023,0 0,0 -0.168702,0.0071 -0.205422,0.0087 -1.324091,0.155941 -1.818701,0.467727 -0.524513,0.330682 -1.411851,1.384772 -1.411851,3.238539 0,1.668409 1.058767,3.243701 1.513345,3.842824 0.0113,0.0151 0.03205,0.04578 0.06214,0.08981 1.740877,2.542402 3.911104,4.426558 6.111137,5.305422 2.118019,0.846039 3.120974,0.943831 3.691169,0.943831 9.7e-5,0 9.7e-5,0 9.7e-5,0 0.23961,0 0.431396,-0.0188 0.600584,-0.03546 l 0.107338,-0.01023 c 0.731688,-0.06487 2.339611,-0.898052 2.705357,-1.914448 0.288117,-0.800552 0.364091,-1.675227 0.172403,-1.992662 -0.131299,-0.215845 -0.357565,-0.324448 -0.644026,-0.461981 z"
          id="XMLID_469_"
          fill="#ffffff"
          fill-rule="nonzero" />
      </g>
      <metadata
        id="metadata13">
        <rdf:RDF>
          <cc:Work
            rdf:about="">
            <dc:title>05DBCE71-FBD0-41A1-B0A6-3D805B1EAF45</dc:title>
          </cc:Work>
        </rdf:RDF>
      </metadata>
    </svg>
  </a>
  `;

  document.body.appendChild(wrapper);
}

function initComponent() {
  setUpMobileNavMenu();
  setUpTabbedContent();
  setUpFooterLinksAccordion();
  setUpDomainPricingAccordion();
  setUpChatWidget();
  setUpSelectInput();
  setUpButtonDropdown();
  setUpHeroCarousel();
}

document.addEventListener('DOMContentLoaded', initComponent);
